
export const PageParagraph = ({ children }) => {

    return (
        <p className="lh-base text-uni">{children}</p>
    )
}
